import { render, staticRenderFns } from "./o-health-text-hero.vue?vue&type=template&id=a8bbdabc&scoped=true"
import script from "./o-health-text-hero.vue?vue&type=script&lang=js"
export * from "./o-health-text-hero.vue?vue&type=script&lang=js"
import style0 from "./o-health-text-hero.vue?vue&type=style&index=0&id=a8bbdabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bbdabc",
  null
  
)

export default component.exports